import React from 'react';

export default function Leaf({
  width = 44,
  height = 'auto'
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 44 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.436 35.414c0 11.2-9.08 20.29-20.29 20.29-11.21 0-20.28-9.09-20.28-20.29 0-17.08 20.29-33.98 20.29-33.98s20.29 16.85 20.29 33.97l-.01.01zM22.156 65.224v-41.07M29.466 29.283l-7.11 8.02M22.156 46.203l-8.07-8.5"
        stroke="#F9F3E5"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}
